/**
 * Enum for chart type
 */
export enum ChartType {
  Line = 'Line',
  Bar = 'Bar',
  Pie = 'Pie',
  Gauge = 'Gauge',
  Area = 'Area',
  Radar = 'Radar',
  Scatter = 'Scatter',
  Heatmap = 'Heatmap',
  Funnel = 'Funnel',
  TreeMap = 'TreeMap',
}
